module.exports = __webpack_public_path__ + "media/images/figure/contract-period-bc3cc28123e0ecf222b618fefd7d9fb1.png";